<template>
  <div :class="'checkbox ' + itemStyle">
    <div class="form-check w-100" :class="checkboxClass">
      <input
        v-bind="$attrs"
        class="form-check-input shadow-none"
        :id="label"
        type="checkbox"
        :checked="checked"
        @change="onChange"
        :disabled="disabled"
      />
      <label :class="'form-check-label border-primary ms-1 ' + labelStyle" :for="label">
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checked: Boolean,
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: `checkbox${Math.random()}`
    },
    disabled: {
      type: Boolean,
      default: false
    },
    itemStyle: {
      type: String,
      default: ''
    },
    labelStyle: {
      type: String,
      default: ''
    },
    checkboxClass: {
      type: String,
      default: ''
    }
  },
  emits: ['change', 'update:modelValue'],
  methods: {
    onChange($event) {
      const val = $event.target.checked ? (this.$attrs.value ?? true) : $event.target.checked

      this.$emit('update:modelValue', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped>
.checkbox {
  .form-check-input {
    width: 16px;
    height: 16px;
    border: 1.3px solid var(--neutral-950);

    &:checked {
      background-color: var(--primary);
      border-color: var(--primary);
    }

    &:hover {
      border-color: var(--primary);
    }

    &:disabled:not(:checked) {
      background-color: var(--gray-400);
      border: 1.3px solid var(--gray-400);
    }
  }
}
</style>
